import { Star } from 'react-feather';
import styles from './style/Project.Clips.module.css';

type Props = unknown;

export const Cell = (props: Props) => {

  return (
    <div className={styles.disabled}>
      <Star color={`var(--gray-l`} />
    </div>
  );
};

Cell.displayName = 'Column.GoodQuote.Cell';